import React, { useState, useEffect } from 'react';

import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import useUsersApi from 'on_web/hooks/useUsersApi';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import UserProfileContext from 'on_web/context/userProfileContext';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';
import Button from 'on_web/components/shared/Common/Button';
import { Divider, Grid } from '@material-ui/core';
import { brainTreeLogo } from 'on_web/assets/imageList';
import './DnaPayment.css';

export default function DnaUploadFile(props) {
  const context = React.useContext(UserProfileContext);
  const [brainTreeInstance, setBrainTreeInstance] = useState(null);
  const [paymentProcessed, setPaymentProcessed] = useState(false);
  const [userPaid, setUserPaid] = useState(undefined);
  const [productData, setProductData] = useState(null);
  const [
    { initiatePayment, errorInitiatePayment, getPaymentData, getProductsData },
  ] = useUsersApi();

  const [isDesktop] = useCheckScreenSize();

  const { t } = useTranslation();

  useEffect(() => {
    getPaymentData()
      .then(resp => {
        if (resp != null && resp.length !== 0) {
          resp.forEach(payment => {
            if (
              payment.completed_at != null &&
              payment.transaction != null &&
              payment.product === 'dna-blood-analysis'
            ) {
              setUserPaid(true);
              return;
            }
          });
        } else {
          setUserPaid(false);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, [getPaymentData]);

  useEffect(() => {
    getProductsData()
      .then(resp => {
        if (resp != null && resp.length !== 0) {
          resp.forEach(product => {
            if (
              product.title != null &&
              product.price != null &&
              product.sku === 'dna-blood-analysis'
            ) {
              setProductData({
                title: product.title,
                price: product.price,
              });
            }
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  }, [getProductsData]);

  const getBraintreeId = () => {
    if (process.env.REACT_APP_BT_ID) {
      return process.env.REACT_APP_BT_ID;
    }

    return 'sandbox_s93h2n64_w5sdbqd8hkq85fvv';
  };

  useEffect(() => {
    const dropin = require('braintree-web-drop-in');
    if (dropin) {
      dropin.create(
        {
          authorization: getBraintreeId(),
          container: '#dropin-container',
          paypal: {
            flow: 'checkout',
            amount: '39.00',
            currency: 'USD',
          },
          card: {
            cardholderName: {
              required: true,
            },
          },
        },
        function(createErr, instance) {
          setBrainTreeInstance(instance);
          instance.on('paymentOptionSelected', function(event) {
            // event.paymentOption = paypal | card
            setTimeout(function() {
              document.documentElement.scrollTop =
                document.documentElement.scrollHeight;
            }, 50);
          });
        }
      );
    }
  }, []);

  useEffect(() => {
    if (errorInitiatePayment != null && errorInitiatePayment !== '') {
      alert('Payment failed');
    }
  }, [errorInitiatePayment]);

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.userPaid = userPaid || paymentProcessed;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const onInitiatePayment = () => {
    brainTreeInstance.requestPaymentMethod(function(
      requestPaymentMethodErr,
      payload
    ) {
      initiatePayment({
        product: 'dna-blood-analysis',
        payment_method_nonce: payload.nonce,
        device_data: 'dummy-data',
      }).then(resp => {
        if (
          resp != null &&
          resp.length !== 0 &&
          resp.completed_at != null &&
          resp.transaction != null &&
          resp.product != null
        ) {
          setPaymentProcessed(true);
        } else {
          alert('Payment failed!');
        }
      });
    });
  };

  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}
      <SectionTitle text={t('onboarding.dnaSection.dnaPayment.sectionTitle')} />
      <Box display="flex">
        <Grid
          container
          direction={isDesktop ? 'row' : 'column'}
          display="flex"
          alignItems={isDesktop ? 'flex-start' : 'center'}
          justify="center"
          style={{
            marginTop: '30px',
          }}
        >
          <Grid item>
            {productData != null && (
              <Grid
                container
                direction="column"
                display="flex"
                alignItems="center"
                justify="center"
                style={{
                  marginRight: isDesktop ? '30px' : 0,
                  borderRadius: '9px',
                  border: 'solid 1px #d8d8d8',
                }}
              >
                <Grid item>
                  <Box mt={2} mb={2} display="flex">
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                      {t('onboarding.dnaSection.dnaPayment.yourOrder')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                  <Divider />
                </Grid>
                <Grid item>
                  <Box mt={2} mb={1}>
                    <Typography
                      variant="body1"
                      align="center"
                      style={{ fontWeight: '300', fontSize: '14px' }}
                    >
                      {t('onboarding.dnaSection.dnaPayment.service')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Box
                    width={isDesktop ? 'auto' : '203px'}
                    mb={4}
                    style={{ paddingLeft: '35px', paddingRight: '35px' }}
                  >
                    <Typography variant="h5" align="center">
                      SPARE {productData.title}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Typography
                    mb={1}
                    variant="body1"
                    align="center"
                    style={{ fontWeight: '300', fontSize: '14px' }}
                  >
                    {t('onboarding.dnaSection.dnaPayment.total')}
                  </Typography>
                </Grid>
                <Grid item>
                  <Box mb={2}>
                    <Typography
                      variant="h5"
                      align="center"
                      style={{ fontSize: '30px' }}
                    >
                      ${productData.price}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid item>
            {userPaid !== true ? (
              <>
                <Box style={{ marginTop: isDesktop ? 0 : '30px' }}>
                  <div id="dropin-container"></div>
                  {brainTreeInstance != null && (
                    <Box display="flex" justifyContent="center">
                      <Box paddingTop={{ xs: 2, sm: 0 }}>
                        {paymentProcessed !== true && (
                          <Button
                            disabled={paymentProcessed}
                            variant="contained"
                            color="primary"
                            style={{
                              paddingLeft: '25px',
                              paddingRight: '25px',
                              paddingTop: '10px',
                              paddingBottom: '10px',
                              fontSize: '11px',
                              width: '290px',
                            }}
                            onClick={() => onInitiatePayment()}
                          >
                            {t('onboarding.dnaSection.dnaPayment.payButton')}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  )}
                </Box>
                {productData && (
                  <Box my={4} display="flex" justifyContent="center">
                    <img
                      src={brainTreeLogo}
                      height={'45px'}
                      width={'141px'}
                      alt="Braintree logo"
                    ></img>
                  </Box>
                )}
              </>
            ) : null}
          </Grid>
        </Grid>
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
        nextButtonDisabled={paymentProcessed !== true && userPaid !== true}
      />
    </div>
  );
}
